import { Instagram, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { restaurant, navLinks } from "../mock";
import { useLang } from "../i18n";

const INSTAGRAM_URL = "https://www.instagram.com/quattrotavoli/";

export default function Footer() {
  const { t } = useLang();
  const go = (href) => {
    if (href.startsWith("/") && !href.includes("#")) { window.location.href = href; return; }
    const hash = href.includes("#") ? `#${href.split("#")[1]}` : href;
    if (window.location.pathname !== "/") { window.location.href = `/${hash}`; return; }
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer className="bg-[#2A2420] text-[#FAF4EA]">
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3">
            <img
              src="/logo.webp"
              alt="Quattro Tavoli"
              className="w-12 h-12 rounded-full object-contain bg-white/95 p-0.5"
            />
            <span className="font-display text-2xl font-700">Quattro Tavoli</span>
          </div>
          <p className="mt-5 text-white/60 leading-relaxed max-w-xs font-body">
            {t("footer.tagline")}
          </p>
          <div className="mt-6 flex gap-3">
            <a
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="grid place-items-center w-10 h-10 rounded-full border border-white/15 text-white/70 hover:bg-[#9C3B2E] hover:border-[#9C3B2E] hover:text-white transition-all duration-300"
            >
              <Instagram className="w-5 h-5" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="font-display text-lg font-600 text-[#F0D9A7]">{t("footer.nav")}</h4>
          <ul className="mt-5 space-y-3">
            {navLinks.map((l) => (
              <li key={l.href}>
                <button onClick={() => go(l.href)} className="text-white/60 hover:text-white transition-colors">
                  {t(l.key)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg font-600 text-[#F0D9A7]">{t("footer.contact")}</h4>
          <p className="mt-5 flex items-start gap-2 text-white/60">
            <MapPin className="w-5 h-5 text-[#9C3B2E] mt-0.5 shrink-0" /> {restaurant.address}
          </p>
          <p className="mt-3 text-white/60">{restaurant.phone}</p>
          <p className="mt-1 text-white/60">{restaurant.email}</p>
        </div>
      </div>

      <div className="border-t border-[#F0D9A7]/40">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col items-center gap-3 text-sm sm:flex-row sm:justify-between">
          <p className="text-center text-white/60 sm:text-left">
            © {new Date().getFullYear()} Quattro Tavoli – {t("footer.rights")}
            {" · "}
            <Link
              to="/impressum"
              className="text-[#F0D9A7] underline underline-offset-2 hover:text-white transition-colors"
            >
              Impressum
            </Link>
            {" · "}
            <Link
              to="/datenschutz"
              className="text-[#F0D9A7] underline underline-offset-2 hover:text-white transition-colors"
            >
              Datenschutz
            </Link>
          </p>
          <span className="font-serif-alt italic text-[#F0D9A7]/70">{t("footer.love")} ❤︎</span>
        </div>
      </div>
    </footer>
  );
}